import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const JobApplicationService = {
  create  : async (data) => {
    const response = await apiService.post("/jobapplications",data);
    return response.data;
  },
    
}

export default JobApplicationService
